export enum DataTypeEnum {
  Text = 0,
  Number = 1,
  Date = 2,
  Time = 3,
  DateTime = 4,
  Boolean = 5,
  blob = 6,
  Entity = 7,
  Icon = 8,
  Block = 9,
  LocalizedJson = 10,
  GeoJson = 11,
  Json = 12,
  ObjectJson = 13,
}

export enum ADTType {
  ADTString = 0,
  ADTNumber = 1,
  ADTDate = 2,
  ADTTime = 3,
  ADTDatetime = 4,
}

export enum VirtualFieldTypeEnum {
  Simple = 0,
  Advanced,
}

export interface GeoJsonModel {
  geometry: {
    /**
     * The type of the GeoJSON. For now we are supporting points
     */
    type: 'Point';
    /**
     * The first item in the array is longitude and the second is latitude
     */
    coordinates: number[];
  };
}
